export default "__VITE_ASSET__D6Lk36CE__"